module.exports = __webpack_public_path__ + "img/iosPhoneScreenshot.58b52e17.png";